<template>
  <div class="ProposalDialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      custom-class="proposal_dialog"
      :before-close="handleClose"
    >
      <div class="proposal_title">提交方案</div>
      <el-form ref="proposalForm" :model="form" :rules="rules" label-position="top">
        <el-form-item label="学校名称" prop="school">
          <el-input
            v-model="form.school"
            placeholder="请输入学校名称"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="方案标题" prop="title">
          <el-input
            v-model="form.title"
            placeholder="请输入方案标题"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="方案描述" prop="desc">
          <div ref="descEditorRef" class="proposal_editor"></div>
        </el-form-item>
      </el-form>
      <div class="proposal_footer">
        <el-button class="proposal_cancel" @click="handleClose">取 消</el-button>
        <el-button class="proposal_submit" :loading="loading" @click="handleSubmit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wangEditor from "wangeditor";
import { saveCampusProposalApi } from "@/api/index";

export default {
  name: "ProposalDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      descEditor: null,
      form: {
        school: "",
        title: "",
        desc: "",
      },
      rules: {
        school: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        title: [{ required: true, message: "请输入方案标题", trigger: "blur" }],
        desc: [{ required: true, message: "请输入方案描述", trigger: "change" }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
  },
  watch: {
    //每次打开清空上一轮内容，富文本编辑器等弹窗渲染后再初始化
    visible(val) {
      if (val) {
        this.form.school = "";
        this.form.title = "";
        this.form.desc = "";
        this.$nextTick(() => {
          this.initDescEditor();
          if (this.descEditor) this.descEditor.txt.clear();
          this.form.desc = "";
          if (this.$refs.proposalForm) this.$refs.proposalForm.clearValidate();
        });
      }
    },
    loginPromptSeq() {
      if (this.visible) this.handleClose();
    },
  },
  beforeDestroy() {
    if (this.descEditor) this.descEditor.destroy();
    this.descEditor = null;
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    initDescEditor() {
      if (this.descEditor) return;
      this.descEditor = new wangEditor(this.$refs.descEditorRef);
      this.descEditor.config.height = 180;
      this.descEditor.config.placeholder = "请描述活动策划方案的核心内容、参与形式与预期效果...";
      this.descEditor.config.zIndex = 100;
      this.descEditor.config.onchange = (html) => {
        //纯空白内容按空处理，避免自动生成的 <p><br></p> 通过必填校验
        this.form.desc = this.descEditor.txt.text().trim() ? html : "";
      };
      this.descEditor.create();
    },
    handleSubmit() {
      this.$refs.proposalForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const descHtml = this.descEditor.txt.html();
        saveCampusProposalApi({
          school: this.form.school,
          title: this.form.title,
          desc: descHtml,
        }).then((res) => {
          this.loading = false;
          if (res.code !== 0) {
            this.$message.error(res.msg || "提交失败");
            return;
          }
          this.$message.success(res.msg || "提交成功，等待审核");
          this.$emit("success", res.data || {
            school: this.form.school,
            title: this.form.title,
            desc: descHtml,
          });
          this.descEditor.txt.clear();
          this.form.desc = "";
          this.handleClose();
        }).catch((err) => {
          this.loading = false;
          this.$message.error((err && err.msg) || "提交失败");
        });
      });
    },
  },
};
</script>

<style scoped>
.ProposalDialog >>> .proposal_dialog {
  border-radius: 8px;
}

.ProposalDialog >>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ProposalDialog >>> .proposal_dialog {
  margin: 0 !important;
}

.ProposalDialog >>> .proposal_dialog .el-dialog__header {
  padding: 0;
}

.ProposalDialog >>> .proposal_dialog .el-dialog__body {
  padding: 28px 32px 24px;
}

.proposal_title {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  padding-bottom: 16px;
}

.ProposalDialog >>> .el-form-item {
  margin-bottom: 16px;
}

.ProposalDialog >>> .el-form--label-top .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
}

.proposal_editor {
  margin-bottom: 4px;
}

.ProposalDialog >>> .proposal_editor .w-e-toolbar {
  background-color: #f8f8f8;
  border-color: #e5e5e5 !important;
  border-radius: 4px 4px 0 0;
}

.ProposalDialog >>> .proposal_editor .w-e-text-container {
  border-color: #e5e5e5 !important;
  border-radius: 0 0 4px 4px;
}

.proposal_footer {
  text-align: center;
  padding-top: 8px;
}

.proposal_cancel {
  width: 110px;
  height: 40px;
  border-radius: 8px;
}

.proposal_submit {
  width: 110px;
  height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2968bd, #1b63a7);
  border: none;
  border-radius: 8px;
  margin-left: 16px;
}

.proposal_submit:hover {
  box-shadow: 0 2px 8px rgba(27, 99, 167, .35);
}
</style>


// WEBPACK FOOTER //
// src/views/components/ProposalDialog.vue